"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePendingWithdrawals = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var pay_api_1 = require("@l2p/pay-api");
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var usePendingWithdrawals = function () {
    var _a = (0, useQuery_1.useQuery)({
        path: keys_1.PENDING_WITHDRAWALS,
        payload: {
            status: pay_api_1.TransactionStatusEnum.Pending,
            type: pay_api_1.TransactionTypeEnum.Withdrawal,
        },
        revalidateOnMount: true,
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading;
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        return {
            data: ((_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.transaction) === null || _b === void 0 ? void 0 : _b.get) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d[0])
                ? "".concat((0, apps_shared_1.getCurrencySymbol)((_j = (_h = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.data) === null || _e === void 0 ? void 0 : _e.transaction) === null || _f === void 0 ? void 0 : _f.get) === null || _g === void 0 ? void 0 : _g.edges) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.currency), " ").concat((_p = (_o = (_m = (_l = (_k = data === null || data === void 0 ? void 0 : data.data) === null || _k === void 0 ? void 0 : _k.transaction) === null || _l === void 0 ? void 0 : _l.get) === null || _m === void 0 ? void 0 : _m.edges) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.amount)
                : '',
            isLoading: isLoading,
            error: error,
        };
    }, [data, isLoading, error]);
};
exports.usePendingWithdrawals = usePendingWithdrawals;
